export default function ExpensesRoute() { return null; }
